var _path, _path2, _ellipse, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _rect2, _rect3, _path10, _g, _path11, _g2, _g3, _g4, _g5, _g6, _g7, _path12, _path13, _path14, _path15, _path16, _circle2, _path17, _path18, _path19, _path20, _path21, _path22, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8a77818-6ab0-46b3-bde5-d559b2498a42",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000.09998,
    height: 670.62,
    viewBox: "0 0 1000.09998 670.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1010.56,482.85a455.60315,455.60315,0,0,1-30.18,69.41c-.66,1.22-1.33,2.44-2,3.66V309c.67-2.04,1.34-4.07,2-6.11005,26.9101-82.57995,46.90009-159.04,40.29-188.19995C1022.60992,122.03,1070.48,307.39,1010.56,482.85Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.05,366.48c-.74,4.64-23.65,140.99-119.67,221.94-.66.57-1.33,1.12-2,1.67V516.41c.66-.68,1.33-1.36,2-2.05,9.84-10.1,20.05-20.73,30.18-31.51C1053.99005,436.58,1095.85,387.57,1100.05,366.48Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.5,
    cy: 660.62,
    rx: 111.5,
    ry: 10,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M974.38,234.31H342.83a5.99834,5.99834,0,0,0-6,6v350a5.99834,5.99834,0,0,0,6,6H974.38a5.99834,5.99834,0,0,0,6-6v-350A5.99834,5.99834,0,0,0,974.38,234.31Zm4,356a3.9989,3.9989,0,0,1-4,4H342.83a3.99891,3.99891,0,0,1-4-4v-350a3.99887,3.99887,0,0,1,4-4H974.38a3.99887,3.99887,0,0,1,4,4Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 298.88965,
    y: 119.62,
    width: 2,
    height: 362,
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.64136,265.50787a18.65433,18.65433,0,1,1,18.65432,18.65432A18.67542,18.67542,0,0,1,350.64136,265.50787Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.64136,338.50787a18.65433,18.65433,0,1,1,18.65432,18.65432A18.67542,18.67542,0,0,1,350.64136,338.50787Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M350.64136,411.50787a18.65433,18.65433,0,1,1,18.65432,18.65432A18.67542,18.67542,0,0,1,350.64136,411.50787Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.93517,263.66776h5.52036v-5.52041a1.84016,1.84016,0,1,1,3.68031,0v5.52041h5.52042a1.84013,1.84013,0,0,1,0,3.68026h-5.52042v5.52042a1.84016,1.84016,0,0,1-3.68031,0V267.348h-5.52036a1.84013,1.84013,0,1,1,0-3.68026Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M365.80562,343.7057h15.61746a.31786.31786,0,0,0,.05836-.00462l-7.38634-12.79421a.51718.51718,0,0,0-.90025,0l-4.95716,8.58591-.23749.41084Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.856 229.016 271.188 229.016 268.57 225.214 268.382 224.94 268.288 224.803 268.05 225.214 265.856 229.016",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.10992,343.7057h13.50783l-2.61755-3.80209-.18837-.27389-3.41091-4.95485a.69017.69017,0,0,0-1.02448-.06125.61515.61515,0,0,0-.04912.06125Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.3406,
    cy: 216.9336,
    r: 2.31359,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 436.77138,
    y: 373.99765,
    width: 290.48545,
    height: 1.83702,
    transform: "translate(-205.74206 339.12635) rotate(-39.33239)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 581.09567,
    y: 229.84117,
    width: 1.83687,
    height: 291.06852,
    transform: "translate(-177.75552 471.12596) rotate(-50.50975)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M691.03194,279.58811H472.41545a6.4374,6.4374,0,0,0-6.42987,6.4299V463.2994a6.43768,6.43768,0,0,0,6.42987,6.4299H691.03194a6.4374,6.4374,0,0,0,6.42987-6.4299V286.018a6.43712,6.43712,0,0,0-6.42987-6.4299ZM472.41545,467.8922a4.59821,4.59821,0,0,1-4.59277-4.5928V286.018a4.5982,4.5982,0,0,1,4.59277-4.5928H691.03194a4.59819,4.59819,0,0,1,4.59277,4.5928V463.2994a4.5982,4.5982,0,0,1-4.59277,4.5928Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b7202e77-47b3-4d88-8d2a-2206841e46b2",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.16394,379.45515c-1.88045.04057-3.37981,2.07827-3.34893,4.55127.03013,2.41577,1.512,4.36457,3.34893,4.40424H910.1096c1.88045.04056,3.42983-1.93123,3.46074-4.40424s-1.46855-4.5107-3.34893-4.55127q-.05591-.00125-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "bfc1215b-6465-4563-8feb-7e589d2c97b6",
    "data-name": "Path 40",
    d: "M733.16394,353.51157c-1.88045.04057-3.37981,2.07827-3.34893,4.55128.03013,2.41577,1.512,4.36457,3.34893,4.40423h95.91554c1.88044.04057,3.42983-1.93123,3.46073-4.40423s-1.46854-4.51071-3.34893-4.55128q-.05591-.00123-.1118,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#6c63ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e482ad8c-5b59-4aa3-8d0a-acebf632571d",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.16394,406.63414c-1.88045.04056-3.37981,2.07826-3.34893,4.55127.03013,2.41577,1.512,4.36457,3.34893,4.40423H910.1096c1.88045.04057,3.42983-1.93123,3.46074-4.40423s-1.46855-4.51071-3.34893-4.55127q-.05591-.00125-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "a4240805-a668-4077-939e-34c0ef9642f4",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.16394,433.375c-1.88045.04056-3.37981,2.07826-3.34893,4.55127.03013,2.41577,1.512,4.36457,3.34893,4.40423H910.1096c1.88045.04057,3.42983-1.93123,3.46074-4.40423s-1.46855-4.51071-3.34893-4.55127q-.05591-.00125-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ecd3311d-200b-4df1-9e16-2b2cfcf2d576",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.16394,460.55394c-1.88045.04057-3.37981,2.07827-3.34893,4.55127.03013,2.41578,1.512,4.36457,3.34893,4.40424H910.1096c1.88045.04056,3.42983-1.93123,3.46074-4.40424s-1.46855-4.5107-3.34893-4.55127q-.05591-.00125-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "b12ed9b2-cc32-4c4f-a9d5-2d1deb4d0e3e",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.42128,488.156c-1.88045.04057-3.37981,2.07827-3.34893,4.55127.03013,2.41577,1.512,4.36457,3.34893,4.40423H911.36694c1.88045.04057,3.42983-1.93123,3.46074-4.40423s-1.46855-4.5107-3.34893-4.55127q-.05591-.00124-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e10bb4bc-6df1-41b6-ac46-84090840b498",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.42128,515.33494c-1.88045.04057-3.37981,2.07827-3.34893,4.55127.03013,2.41578,1.512,4.36458,3.34893,4.40424H911.36694c1.88045.04057,3.42983-1.93123,3.46074-4.40424s-1.46855-4.5107-3.34893-4.55127q-.05591-.00124-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "e3c0a870-6a35-4470-a43f-0902a465f5fb",
    "data-name": "Path 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.42128,542.07577c-1.88045.04056-3.37981,2.07826-3.34893,4.55127.03013,2.41577,1.512,4.36457,3.34893,4.40423H911.36694c1.88045.04057,3.42983-1.93123,3.46074-4.40423s-1.46855-4.51071-3.34893-4.55127q-.05591-.00125-.11181,0Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M279.49814,746.21972l-26.89556-.84489L213.95,584.31,148.02052,742.08953l-30.10824-.94579c28.62353-122.86286,57.42294-247.98953,79.19838-282.70841l60.46743,17.50374Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M162.72514,779.51364l-1.86658.14932a12.1009,12.1009,0,0,1-5.524-.85309L119.10968,774.517a12.50384,12.50384,0,0,1-6.83124-16.39168L120.11816,739.31h25.38L171.716,760.57265A12.101,12.101,0,0,1,162.72514,779.51364Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M295.72514,779.51364l-1.86658.14932a12.1009,12.1009,0,0,1-5.524-.85309L252.10968,774.517a12.50384,12.50384,0,0,1-6.83124-16.39168L253.11816,739.31h25.38L304.716,760.57265A12.101,12.101,0,0,1,295.72514,779.51364Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M274.8406,435.56805l-47.52623-31.32662,21.96851-13.30371,31.10965,19.25371,50.60455,7.56154,7.6931-7.62731a11.958,11.958,0,0,1,18.5006,2.06068l0,0a11.958,11.958,0,0,1-7.3586,18.075l-7.59185,1.77527Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.55663,412.82559c-5.30778-10.98244-14.54582-19.98944-27.09742-27.33114l24.66931-24.73628c11.87116,6.69278,22.28841,17.40169,31.97,30.14333Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.63006,
    cy: 192.10195,
    r: 27.48195,
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M240.47217,362.86465l-35.00746-8.75187c3.12656-8.93456,1.95759-22.35483,0-36.5987h35.00746C235.3746,334.13766,233.92322,350.08264,240.47217,362.86465Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#a0616a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.56714,482.20825l-65.639-15.02106c-6.94011-48.36987-8.417-98.85458,12.33217-116.25689l32.62059,3.97811,24.58925,31.53838a42.70444,42.70444,0,0,1,4.86134,7.861c5.28689,11.07441,4.28556,24.02426-1.78881,34.68708C257.31173,445.19868,254.49214,462.82667,259.56714,482.20825Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.14422,450.4616l10.70612-55.906,20.71117,15.18722-5.85169,36.11473,32.30089,39.39574,9.99437,4.18a11.958,11.958,0,0,1,5.19152,17.87642l0,0a11.958,11.958,0,0,1-19.515.13545l-4.5509-6.33065Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.62322,383.47077c-4.49819,11.33811-4.88291,24.2346-1.79972,38.445L199.918,420.47939c-3.10085-13.27036-2.26034-28.18658.57487-43.936Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M238.48311,276.53944S205.86252,258.24009,189.95,291.6563s-11.13873,62.8543-11.13873,62.8543L209.045,353.715l7.16062-7.16061,5.56937,6.365.08459-.13706A93.83861,93.83861,0,0,0,235.25606,308.904c.2534-4.24156,1.71536-8.13782,5.61392-10.0871,11.13874-5.56936,13.52561-5.56936,13.52561-5.56936S260.76058,278.13069,238.48311,276.53944Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M376.79568,403.50787h-14.893a2.07446,2.07446,0,0,0-2.07966,1.6641,2.00138,2.00138,0,0,0,1.97262,2.3359h4.43111a1.06889,1.06889,0,0,1,1.06889,1.06889v8.82407a2.07447,2.07447,0,0,0,1.6641,2.07966,2.00137,2.00137,0,0,0,2.3359-1.97262v-8.93111a1.0689,1.0689,0,0,1,1.0689-1.06889h4.32418a2.07438,2.07438,0,0,0,2.07957-1.66421A2.00135,2.00135,0,0,0,376.79568,403.50787Z",
    transform: "translate(-99.95001 -114.69)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.84567,
    cy: 302.81786,
    r: 2,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseTemplate);
export default __webpack_public_path__ + "static/media/choose_template.804a805430acb43d13bf3c69cca42876.svg";
export { ForwardRef as ReactComponent };